export default __webpack_public_path__ + "static/media/new_file.1997268d.svg";